// @ts-nocheck

import InputLabelField from '@/components/form-control/InputLabelField'
import { CONFIG_NAME_MAX_LENGTH } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import { useConfigUI } from '@/features/config/context'
import useAddSubArea from '@/features/config/hooks/areasandzones/useAddSubArea'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  Container,
  FormControl,
  Stack,
  Typography,
} from '@mui/material'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import useTranslation from '@/hooks/useTranslation'

interface AddSubAreaViewProps {
  id?: number
  parentName?: string
}


const AddSubAreaView = ({ id, parentName }: AddSubAreaViewProps) => {
  const { t } = useTranslation()
  const { closeSidebar } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const { mutate: addSubArea, isLoading: loadingAddSubArea } = useAddSubArea()
  const schema = yup
    .object({
      name: yup
        .string()
        .trim()
        .required(t('formsValidationSubAreaNameIsRequired'))
        .max(CONFIG_NAME_MAX_LENGTH, `Maximum ${CONFIG_NAME_MAX_LENGTH} characters`),
    })
    .required()

  const inputRefSiteName = useRef<HTMLInputElement>(null)
  const form = useForm({
    defaultValues: {
      parentId: id ? id : 0,
      parentName: parentName ? parentName : '',
      name: '',
    },
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])

  const handleSave = (data: any) => {
    addSubArea({
      interfaceId: interfaceId,
      name: data.name,
      parentId: data.parentId,
    })
  }

  return (
    <Container sx={{ maxWidth: '450px' }}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <Stack sx={{ padding: '34px 18px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              marginBottom: '20px',
              width: '377px',
            }}
          >
            <Typography>{t('commonActionsAdd')} {t('subArea')}</Typography>
            <Stack direction="row">
              <Button
                variant="secondary"
                size="small"
                sx={{ marginRight: '7px', width: '85px' }}
                onClick={() => closeSidebar()}
              >
                {t('commonActionsCancel')}
              </Button>
              <LoadingButton
                size="small"
                loading={loadingAddSubArea}
                variant="primary"
                sx={{ minWidth: '72px' }}
                type="submit"
              >
                {t('commonActionsSave')}
              </LoadingButton>
            </Stack>
          </Stack>

          <Stack>
            <FormControl
              variant="standard"
              sx={{
                minWidth: '377px',
                minHeight: '50px',
                marginTop: '8px',
                backgroundColor: 'background.default',
                borderRadius: '4px',
              }}
              disabled
            >
              <InputLabelField
                name="parentName"
                form={form}
                label={t('AreaName')}
                padding="8px 12px"
                disabled={true}
              />
            </FormControl>
          </Stack>

          <InputLabelField
            name="name"
            form={form}
            maxLength={CONFIG_NAME_MAX_LENGTH}
            label={t('SubAreaName')}
            placeholder={t('formsLabelsSubArea')}
            inputRef={inputRefSiteName}
            style={{
              marginTop: '8px',
              borderRadius: '4px',
              width: { xs: '377px' },
            }}
            padding="8px 16px"
          />
        </Stack>
      </form>
    </Container>
  )
}

export default AddSubAreaView
